function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "login",
  transform: "translate(-120.000000, -687.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "login-google",
  transform: "translate(100.000000, 672.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-google",
  transform: "translate(20.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.43242187,12.08625 L3.73625,14.6851563 L1.19175781,14.7389844 C0.431328125,13.3285547 0,11.7148438 0,10 C0,8.34175781 0.40328125,6.77800781 1.118125,5.40109375 L1.11867187,5.40109375 L3.38398437,5.81640625 L4.37632812,8.068125 C4.16863281,8.67363281 4.05542969,9.32363281 4.05542969,10 C4.05550781,10.7340625 4.18847656,11.4373828 4.43242187,12.08625 Z",
  id: "Path",
  fill: "#FBBB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.8252734,8.131875 C19.9401172,8.73679687 20,9.36152344 20,10 C20,10.7159375 19.9247266,11.4142969 19.7813281,12.0879297 C19.2945312,14.3802344 18.0225391,16.381875 16.2604687,17.7983594 L16.2599219,17.7978125 L13.4066406,17.6522266 L13.0028125,15.1313281 C14.1720312,14.445625 15.0857812,13.3725391 15.5671094,12.0879297 L10.2198438,12.0879297 L10.2198438,8.131875 L15.6451172,8.131875 L19.8252734,8.131875 L19.8252734,8.131875 Z",
  id: "Path",
  fill: "#518EF8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2598828,17.7978125 L16.2604297,17.7983594 C14.5467188,19.1758203 12.3697656,20 10,20 C6.19175781,20 2.88078125,17.8714453 1.19175781,14.7390234 L4.43242187,12.0862891 C5.27691406,14.3401172 7.45109375,15.9445313 10,15.9445313 C11.0955859,15.9445313 12.1219922,15.6483594 13.0027344,15.1313281 L16.2598828,17.7978125 Z",
  id: "Path",
  fill: "#28B446"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.3829687,2.3021875 L13.1433984,4.954375 C12.231875,4.38460937 11.154375,4.05546875 10,4.05546875 C7.39339844,4.05546875 5.17855469,5.73347656 4.37636719,8.068125 L1.11867187,5.40109375 L1.118125,5.40109375 C2.78242187,2.19230469 6.13515625,0 10,0 C12.4263672,0 14.6510937,0.864296875 16.3829687,2.3021875 Z",
  id: "Path",
  fill: "#F14336"
})))));

function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-google") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.cb786265.svg";
export { ForwardRef as ReactComponent };